export const getScoreColorClass = (score: number): string => {
  if (score >= 75) return "text-green-600 bg-green-50";
  if (score >= 50) return "text-yellow-600 bg-yellow-50";
  return "text-red-600 bg-red-50";
};

export const getScoreTextColor = (score: number | null): string => {
  if (score === null) return "text-muted-foreground";
  if (score >= 75) return "text-green-600";
  if (score >= 50) return "text-yellow-600";
  return "text-red-600";
};

export const getScoreBgColor = (score: number | null): string => {
  if (score === null) return "bg-slate-100";
  if (score >= 75) return "bg-green-100";
  if (score >= 50) return "bg-yellow-100";
  return "bg-red-100";
};
